<div class="w-full">
    <div class="bg-card shadow rounded-2xl p-5 m-4" #pageContainer>
        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-6 truncate">
            Well Healthiness Status
        </div>
        <div class="w-full grid grid-cols-1">
            <form [formGroup]="searchForm">
                <app-table-filter [searchForm]="searchForm" class="text-primary"
                    (searchTriggered)="handleSearch($event)">
                </app-table-filter>
                <div class="grid grid-cols-1 sm:grid-cols-3">
                    <div class="flex justify-start col-span-2">
                        <div class="w-19 ml-2">
                            <mat-form-field class="w-full no-bottom-gap mb-2">
                                <mat-select formControlName="PageSize">
                                    <mat-option [value]="10"> 10 </mat-option>
                                    <mat-option [value]="20"> 20 </mat-option>
                                    <mat-option [value]="50"> 50 </mat-option>
                                    <mat-option [value]="100"> 100 </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <app-sort-menu class="mx-2" [columns]="columnSort" [orderDir]="'asc'" [initialOrderKeys]="[]"
                            (apply)="applySort($event)">
                        </app-sort-menu>

                        <button class="btn btn-outline btn-default dt-download" matTooltip="Download Records"
                            [matMenuTriggerFor]="downloadMenu">
                            <mat-icon class="text-primary hover:text-white"
                                svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                        </button>
                        <mat-menu #downloadMenu="matMenu">
                            <button mat-menu-item (click)="downloadWellHelthiness()">
                                Excel
                            </button>
                        </mat-menu>
                    </div>

                    <div class="flex justify-end">
                        <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                            Search
                        </button>
                        <button class="btn btn-outline btn-default" (click)="reset()">
                            Reset
                        </button>
                        <button class="btn btn-outline btn-default mx-2 hover:text-white" matTooltip="Refresh Table"
                            (click)="setPage({ offset: dt.page.offset })">
                            <mat-icon class="text-primary hover:text-white"
                                svgIcon="heroicons_solid:arrow-path"></mat-icon>
                        </button>
                    </div>

                    <div class="flex justify-start col-span-2">
                        <span class="self-center font-medium text-gray-400 italic text-md p-2">
                            Sorting by {{ sortInfo }}
                        </span>
                    </div>

                    <div class="flex justify-end">
                        <span class="self-center font-medium text-primary text-md p-2">
                            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }}
                                </span>
                    </div>
                </div>
            </form>

            <div class="grid overflow-x-auto">
                <!-- Header -->
                <div class="table-well-hralthiness-status-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                    matSort matSortDisableClear>
                    <div class="border py-8 text-center">No</div>

                    <div [mat-sort-header]="'fieldLongName'"
                        class="flex justify-center border py-4 my-custom-sort-header">
                        Field
                    </div>

                    <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4">
                        Platform
                    </div>

                    <div [mat-sort-header]="'wellLongName'" class="flex justify-center border py-4">
                        Well
                    </div>

                    <div [mat-sort-header]="'stringShortName'" class="flex justify-center border py-4">
                        Well String
                    </div>

                    <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                        String Indicator
                    </div>

                    <div [mat-sort-header]="'wellHealthinessStatus'" class="flex border justify-center py-4">
                        Well Healthiness Status
                    </div>

                    <div [mat-sort-header]="'riskRanking'" class="flex border justify-center py-4">
                        Risk Ranking
                    </div>

                    <div [mat-sort-header]="'updateDate'" class="flex border justify-center py-4">
                        Status Updated At
                    </div>

                    <div [mat-sort-header]="'updateBy'" class="flex border justify-center py-4">
                        Status Updated By
                    </div>

                    <div [mat-sort-header]="'status'" class="flex border justify-center py-4">
                        Request Update Status
                    </div>

                    <div [mat-sort-header]="'remarks'" class="flex border justify-center py-4">
                        Remark
                    </div>

                    <div class="block border text-center py-8">Action</div>
                </div>
                <!-- Rows -->
                <ng-container *ngIf="dt.rows.length; else noRecords">
                    <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                        <div class="table-well-hralthiness-status-record-grid grid items-center border-b"
                            [ngClass]="{'bg-primary-100': i % 2 }">
                            <!-- No -->
                            <div class="py-4 text-center">
                                {{startingIndex + i + 1}}.
                            </div>

                            <!-- Field Long Name -->
                            <div class="flex truncate justify-center">
                                {{ row.fieldLongName }}
                            </div>

                            <!-- Platform Long Name  -->
                            <div class="flex justify-center">
                                {{ row.platformLongName }}
                            </div>

                            <!-- Well Long Name  -->
                            <div class="flex justify-center">
                                {{ row.wellLongName }}
                            </div>

                            <!-- String Short Name  -->
                            <div class="text-center">
                                {{ row.stringShortName }}
                            </div>

                            <!-- String Indicator -->
                            <div class="block text-center">
                                {{ row.stringIndicatorShortName }}
                            </div>

                            <!-- Well Healthiness Status -->
                            <div class="block text-center mx-2" [ngClass]="{
                                'healthyBadge': row.wellHealthinessStatus?.toLowerCase() === 'healthy' || row.wellHealthinessStatus?.toLowerCase() === 'healthy with moc',
                                'unhealthyBadge': row.wellHealthinessStatus?.toLowerCase() === 'unhealthy' || row.wellHealthinessStatus?.toLowerCase() === 'unhealthy with moc',
                              }">
                                {{ row.wellHealthinessStatus || '-' }}
                            </div>

                            <!-- Risk Ranking -->
                            <div class="block text-start mx-2 pl-4" [ngClass]="{
                                'risk0Badge': row.riskRanking?.toLowerCase() === 'healthy no risk',
                                'risk1Badge': row.riskRanking?.toLowerCase() === 'healthy low risk',
                                'risk2Badge': row.riskRanking?.toLowerCase() === 'healthy medium risk',
                                'risk3Badge': row.riskRanking?.toLowerCase() === 'unhealthy high risk',
                                'risk4Badge': row.riskRanking?.toLowerCase() === 'unhealthy very high risk',
                              }">
                                {{ row?.riskRanking ? row.scoringMatrix + ' - ' + row.riskRanking : '-' }}
                            </div>

                            <!-- Updated Date -->
                            <div class="block text-center">
                                {{ row.updateDate ? (row.updateDate |
                                date:'dd-MMM-yyyy') : '-' }}
                            </div>

                            <!-- Updated By -->
                            <div class="block text-center">
                                {{ row.updateBy || '-' }}
                            </div>

                            <!-- Request Update Status -->
                            <div class="block text-center mx-2" [ngClass]="{
                                'successBadge': row.status?.toLowerCase() === 'approved',
                                'failedBadge': row.status?.toLowerCase() === 'rejected',
                                'warningBadge': row.status?.toLowerCase() === 'ready to review'
                              }">
                                {{ row.status || '-' }}
                            </div>

                            <!-- Remakrs -->
                            <div class="block pl-4">
                                {{ row.remarks || '-' }}
                            </div>

                            <!-- Action -->
                            <div class="block text-center">
                                <button class="btn btn-remove-bg" (click)="viewCm(row)">
                                    <mat-icon class="text-primary" [svgIcon]="'heroicons_solid:eye'"
                                        matTooltip="View"></mat-icon>
                                </button>

                                <button class="btn btn-remove-bg" (click)="viewWellHealthinessHistory(row)">
                                    <mat-icon class="text-primary" [svgIcon]="'heroicons_outline:document-chart-bar'"
                                        matTooltip="Well Healthiness History"></mat-icon>
                                </button>

                                <button class="btn btn-remove-bg" (click)="editWellHealthiness(row)"
                                    [disabled]="!hasWellHealthinessEditRoles()">
                                    <mat-icon
                                        [matTooltip]="row.status?.toLowerCase() === 'ready to review' ? 'Review Well Healthiness Status' : 'Edit Well Healthiness Status'"
                                        class="text-primary" [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #noRecords>
                    <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                        There are no records registered!
                    </div>
                </ng-template>
            </div>

            <div
                class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
                <div class="content-center px-3">
                    {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'total' : 'totals' }} </div>

                        <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                            [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                            [hidePageSize]="true" [showFirstLastButtons]="true">
                        </mat-paginator>
                </div>
            </div>
        </div>
    </div>

    <ng-template #closedIcon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
    </ng-template>